// extracted by mini-css-extract-plugin
export default {"labeled-box":"labeled-box_labeled-box__gACmT","labeled-box__label":"labeled-box_labeled-box__label__JXOoT","labeled-box__content":"labeled-box_labeled-box__content__CsZLK"};